import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import UserSummary from './UserSummaryComponent';
import { logout } from '@alphapoint/apex-web/lib/redux/actions/authActions';
import { isBrokerUser } from '@alphapoint/apex-web/lib/redux/selectors/userSelectors';

const mapStateToProps = (state) => {
  return {
    isBrokerUser: isBrokerUser(state),
  };
};

const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserSummary));
